var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"15","cy":"15","r":"15","fill":"#1A1718","key":0}),React.createElement("path",{"d":"M14.888 17.448L14.28 10.36V9.8H16.552V10.36L15.96 17.448H14.888ZM14.36 21V18.792H16.488V21H14.36Z","fill":"#FFFFFE","key":1})]);
}

Info.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Info;

Info.default = Info;
